import React from "react";
import { Col, Row } from "antd";
import dayjs from "dayjs";

const QueueSlip = ({ transaction_id, emr_queue_no, isCsr }) => {
    const displayNumber = emr_queue_no || transaction_id;

    return (
        <Row className="font-regular">
            <Col
                span={24}
                className="p-4"
            >
                <Row className="my-4">
                    <Col span={24} className="flex justify-center text-[200px] font-bold text-center" style={{ fontSize: '80px', lineHeight: '1.2' }}>
                        {displayNumber}
                    </Col>
                </Row>
                {
                    !isCsr && (
                        <Row>
                            <Col span={24} className="flex justify-center text-5xl font-bold text-center" style={{ fontSize: '45px' }}>
                                PLEASE PROCEED TO EMR
                            </Col>
                        </Row>
                    )
                }
                <Row>
                    <Col span={24} className="flex text-center justify-center text-6xl" style={{ fontSize: '32px', fontWeight: 'bold' }}>
                        YOU WILL BE SERVED SHORTLY
                    </Col>
                </Row>
                <Row>
                    <Col span={24} className="flex justify-center text-4xl text-center" style={{ fontSize: '30px' }}>
                        {dayjs().format("MMM DD, YYYY hh:mm A")}
                    </Col>
                </Row>
            </Col>
        </Row>
    );
};

export default QueueSlip;